// extracted by mini-css-extract-plugin
module.exports = {"slot":"DaySlot_slot__xmGj0","slot-text":"DaySlot_slot-text__3SI1L","slot-hidden":"DaySlot_slot-hidden__353w3"};